import { render, staticRenderFns } from "./four.vue?vue&type=template&id=74d4c450&scoped=true&"
import script from "./four.vue?vue&type=script&lang=js&"
export * from "./four.vue?vue&type=script&lang=js&"
import style0 from "./four.vue?vue&type=style&index=0&id=74d4c450&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d4c450",
  null
  
)

export default component.exports